module.exports = __webpack_public_path__ + "img/nivel_luz_gray.fa8861d1.svg";